import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const HistoryConcernsSection = ({
  sessionFormData,
  updateFormData,
  durationError,
  frequencyError,
  severityError,
  setDurationError,
  setFrequencyError,
  setSeverityError
}) => {
  return (
    <Card id="history-concerns" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        History of Presenting Concerns
      </h3>
      <div className={styles.historySelectRow}>
        <div className={styles.historySelectItem}>
          <label className={styles.labelWithMargin}>
            How long has this concern been present?
          </label>
          {durationError && (
            <div className={styles.errorMessage}>
              {durationError}
            </div>
          )}
          <select
            value={sessionFormData.duration}
            onChange={(e) => {
              updateFormData("duration", e.target.value);
              if (durationError) {
                setDurationError("");
              }
              if (!e.target.value || e.target.value === "") {
                setFrequencyError("");
              }
            }}
            className={styles.selectFullWidth}
          >
            <option value="">Duration</option>
            <option value="Less than 1 month">Less than 1 month</option>
            <option value="1–3 months">1–3 months</option>
            <option value="3–6 months">3–6 months</option>
            <option value="6–12 months">6–12 months</option>
            <option value="1–2 years">1–2 years</option>
            <option value="More than 2 years">More than 2 years</option>
            <option value="Unsure">Unsure</option>
          </select>
        </div>
        <div className={styles.historySelectItem}>
          <label className={styles.labelWithMargin}>
            How often do symptoms occur?
          </label>
          {frequencyError && (
            <div className={styles.errorMessage}>
              {frequencyError}
            </div>
          )}
          <select
            value={sessionFormData.frequency}
            onChange={(e) => {
              updateFormData("frequency", e.target.value);
              if (frequencyError) {
                setFrequencyError("");
              }
            }}
            className={styles.selectFullWidth}
          >
            <option value="">Frequency</option>
            <option value="Daily">Daily</option>
            <option value="Several times per week">Several times per week</option>
            <option value="Weekly">Weekly</option>
            <option value="A few times per month">A few times per month</option>
            <option value="Occasionally">Occasionally</option>
            <option value="Rarely">Rarely</option>
            <option value="Unsure">Unsure</option>
          </select>
        </div>
        <div className={styles.historySelectItem}>
          <label className={styles.labelWithMargin}>
            How severe are the symptoms?
          </label>
          {severityError && (
            <div className={styles.errorMessage}>
              {severityError}
            </div>
          )}
          <select
            value={sessionFormData.severity}
            onChange={(e) => {
              updateFormData("severity", e.target.value);
              if (severityError) {
                setSeverityError("");
              }
            }}
            className={styles.selectFullWidth}
          >
            <option value="">Severity</option>
            <option value="Mild (noticeable but manageable)">Mild (noticeable but manageable)</option>
            <option value="Moderate (causes some difficulty in functioning)">Moderate (causes some difficulty in functioning)</option>
            <option value="Severe (significantly affects daily life)">Severe (significantly affects daily life)</option>
            <option value="Very Severe (incapacitating or crisis-level)">Very Severe (incapacitating or crisis-level)</option>
          </select>
        </div>
      </div>

      <div>
        <label className={styles.labelWithMargin}>
          Notes on history, past interventions
        </label>
        <textarea
          value={sessionFormData.freeTextHistory}
          onChange={(e) => updateFormData("freeTextHistory", e.target.value)}
          placeholder="Free-text"
          className={styles.textarea}
        />
      </div>
    </Card>
  );
};

export default HistoryConcernsSection;

